module.exports = __webpack_public_path__ + "img/asset_ETH-SOL.2d0395d1.png";